import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=3f710715&scoped=true&"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalRecord.vue?vue&type=style&index=0&id=3f710715&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f710715",
  null
  
)

export default component.exports